import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';

import {
  MdThumbUp,
  MdThumbUpOffAlt,
  MdThumbDown,
  MdThumbDownOffAlt,
} from 'react-icons/md';
import {
  ArticleCommentItem,
  CommentItemHeader,
  CommentItemBody,
  CommentItemFooter,
  ImageAvatarComment,
  ThreadItemCreatedAt,
  CommentCreatedAt,
  SpanCircle,
  VoteThreadButton,
} from '../../styled';
import { showFormattedDate } from '../../../utils';

const CommentItem = ({
  id,
  content,
  createdAt,
  upVotesBy,
  downVotesBy,
  owner,
  downVoteComment,
  neutralVoteComment,
  upVoteComment,
}) => {
  const { authUser } = useSelector((states) => states);
  const { name, avatar } = owner;

  const downVoteLength = downVotesBy.length;
  const upVoteLength = upVotesBy.length;

  const upVoted = upVotesBy.find((upVote) => upVote === authUser.id);
  const downVoted = downVotesBy.find((downVote) => downVote === authUser.id);

  return (
    <ArticleCommentItem>
      <CommentItemHeader>
        <ImageAvatarComment src={avatar} alt="Avatar" />
        &nbsp;&nbsp;
        <CommentCreatedAt>
          @
          {name}
        </CommentCreatedAt>
        &nbsp;&nbsp;
        <SpanCircle>·</SpanCircle>
        &nbsp;&nbsp;
        <CommentCreatedAt>{showFormattedDate(createdAt)}</CommentCreatedAt>
      </CommentItemHeader>
      <CommentItemBody dangerouslySetInnerHTML={{ __html: content }} />
      <CommentItemFooter>
        {upVoted !== undefined
          ? <VoteThreadButton type="button" aria-label="up-votes" title="up-votes" onClick={() => neutralVoteComment({ id })}><MdThumbUp className="thread-icon" /></VoteThreadButton>
          : <VoteThreadButton type="button" aria-label="up-votes" title="up-votes" onClick={() => upVoteComment({ id })}><MdThumbUpOffAlt className="thread-icon" /></VoteThreadButton>}
        <CommentCreatedAt>{upVoteLength}</CommentCreatedAt>
        &nbsp;&nbsp;&nbsp;&nbsp;
        {downVoted !== undefined
          ? <VoteThreadButton type="button" aria-label="down-votes" title="down-votes" onClick={() => neutralVoteComment({ id })}><MdThumbDown className="thread-icon" /></VoteThreadButton>
          : <VoteThreadButton type="button" aria-label="down-votes" title="down-votes" onClick={() => downVoteComment({ id })}><MdThumbDownOffAlt className="thread-icon" /></VoteThreadButton>}
        <ThreadItemCreatedAt>{downVoteLength}</ThreadItemCreatedAt>
      </CommentItemFooter>
    </ArticleCommentItem>
  );
};

const commentItemShape = {
  id: PropTypes.string.isRequired,
  content: PropTypes.string.isRequired,
  createdAt: PropTypes.string.isRequired,
  downVoteComment: PropTypes.func,
  neutralVoteComment: PropTypes.func,
  upVoteComment: PropTypes.func,
};

CommentItem.propTypes = {
  ...commentItemShape,
};

export { commentItemShape };
export default CommentItem;
